module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Enormous thanks to Helen Garnons-Williams, Lisa Moran and Ed Victor. Also to the Writers Guild of America and the Screen Actors Guild, whose threatened strikes put me on hiatus and into prose.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b9b4e00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded1.vue
// module id = 72
// module chunks = 0